export default __webpack_public_path__ + "media/titles/title_1_locale_nb-029fb238.png";